// utils/postalZone.ts — validasi silang kode pos vs provinsi (SATU-SATUNYA peta).
// Insiden #451c1d74 (2026-10-05): kode pos 65311 (Malang) tersimpan dengan kota
// Makassar → tarif intra-Jawa Rp9.435 dipakai utk rute Sulawesi. Prefix 2 digit.
// Insiden 2026-10-17 (order 3a746159, Sumba/NTT): prefix 87 (Sumba) TIDAK ada di
// daftar NTT → "Kode pos tidak sesuai provinsi" memblokir SIMPAN ongkir manual CS
// (dan checkout publik wilayah Sumba). Dilengkapi jadi 84/85/86/87.
// Insiden 2026-10-20 (order c713c9ad, Karanganyar/Jateng): prefix 56-59 (Solo
// Raya, Magelang, pantura timur: 57783 Karanganyar) TIDAK ada di daftar Jateng
// → false-positive yang sama. Dilengkapi jadi 50-59 (kecuali 55 = DIY).
// Insiden 2026-10-24 (order 1024a664, Pesa/Wawo/Bima/NTB): prefix 84 (Bima,
// Dompu, Sumbawa: 841xx–844xx) TIDAK ada di daftar NTB (cuma 83) → CS tak bisa
// simpan edit alamat ("Kode pos tidak sesuai dengan provinsi"). Sumber rentang
// resmi: Kepmendagri via Everpro (NTB 83115–84459 = 83+84; NTT 85111–87284 =
// 85–87; Sumsel 30111–32388 = 30–32; Kaltim +773xx Berau = 75–77).
// Pelajaran: tiap prefix hilang = satu wilayah diblokir. Kalau tambah kasus,
// WAJIB tambah test di postalZone.test.ts.

function norm(s: unknown): string {
  return String(s || '').toLowerCase()
    .replace(/^(provinsi|propinsi|daerah|kabupaten|kab\.?|kota|kodya)\s+/i, '')
    .replace(/[^a-z ]/g, '').replace(/\s+/g, ' ').trim();
}

// prefix 2-digit sah per provinsi (rentang diringkas ke daftar prefix).
const PREFIX: Record<string, string[]> = {
  aceh: ['23', '24'],
  'sumatera utara': ['20', '21', '22'], sumut: ['20', '21', '22'],
  'sumatera barat': ['25', '26', '27'], sumbar: ['25', '26', '27'],
  riau: ['28', '29'],
  jambi: ['36', '37'],
  'sumatera selatan': ['30', '31', '32'], sumsel: ['30', '31', '32'],
  'bangka belitung': ['33'], babel: ['33'],
  'kepulauan riau': ['29'], kepri: ['29'],
  bengkulu: ['38', '39'],
  lampung: ['34', '35'],
  jakarta: ['10', '11', '12', '13', '14'], dki: ['10', '11', '12', '13', '14'],
  'jawa barat': ['15', '16', '17', '18', '40', '41', '42', '43', '44', '45', '46'], jabar: ['15', '16', '17', '18', '40', '41', '42', '43', '44', '45', '46'],
  banten: ['15', '16', '42'],
  'jawa tengah': ['50', '51', '52', '53', '54', '56', '57', '58', '59'], jateng: ['50', '51', '52', '53', '54', '56', '57', '58', '59'],
  yogyakarta: ['55'], yogya: ['55'], diy: ['55'],
  'jawa timur': ['60', '61', '62', '63', '64', '65', '66', '67', '68', '69'], jatim: ['60', '61', '62', '63', '64', '65', '66', '67', '68', '69'],
  bali: ['80', '81', '82'],
  'nusa tenggara barat': ['83', '84'], ntb: ['83', '84'],
  'nusa tenggara timur': ['85', '86', '87'], ntt: ['85', '86', '87'],
  'kalimantan barat': ['78', '79'], kalbar: ['78', '79'],
  'kalimantan tengah': ['73', '74'], kalteng: ['73', '74'],
  'kalimantan selatan': ['70', '71', '72'], kalsel: ['70', '71', '72'],
  'kalimantan timur': ['75', '76', '77'], kaltim: ['75', '76', '77'],
  'kalimantan utara': ['77'], kaltara: ['77'],
  'sulawesi utara': ['95'], sulut: ['95'],
  gorontalo: ['96'],
  'sulawesi tengah': ['94'], sulteng: ['94'],
  'sulawesi barat': ['91'], sulbar: ['91'],
  'sulawesi selatan': ['90', '91', '92'], sulsel: ['90', '91', '92'],
  'sulawesi tenggara': ['93'], sultra: ['93'],
  maluku: ['97'],
  'maluku utara': ['97'], malut: ['97'],
  papua: ['98', '99'],
};

// True bila kode pos cocok provinsi. Tak dikenal salah satunya → true (jangan blokir buta).
export function isPostalMatchingProvince(postal: unknown, province: unknown): boolean {
  const pc = String(postal || '').replace(/\D/g, '');
  if (pc.length < 2) return true;
  const list = PREFIX[norm(province)];
  if (!list) return true;
  return list.includes(pc.slice(0, 2));
}
